<template>
  <v-card class="elevation-12" :loading="loading">
    <v-toolbar color="info" dark flat>
      Попытка вручения
    </v-toolbar>

    <v-card-title>

    </v-card-title>
    <v-card-text>
      <v-menu v-model="performDateMenu"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Дата попытки"
              v-model="performDisplayValue"
              readonly
              v-on="on"
          />
        </template>
        <v-date-picker
            v-model="performDate"
            @change="onPerformDateChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :min="performDateMinValue"
            :max="performDateMaxValue"
        />
      </v-menu>


      <v-textarea v-model="note"
                  :auto-grow="true"
                  :clearable="true"
                  :filled="true"
      />
    </v-card-text>
    <v-card-actions>
      <v-btn color="default" text @click="onCloseClicked" :disabled="loading">Закрыть</v-btn>
      <v-spacer/>
      <v-btn color="info" dark @click="onPerformClicked" :disabled="loading">Сохранить</v-btn>
    </v-card-actions>

    <v-snackbar v-model="isPerformFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось сохранить попытку вручения
    </v-snackbar>
  </v-card>
</template>

<script>
import Moment from "moment";
import {required} from 'vuelidate/lib/validators'
import MailService from "@/services/mail.service"
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import {TryPerform} from "@/enums/perform.type";
import {APP_MAIL_PERFORMED} from "@/store/modules/app/actions";

export default {
  name: "TryPerform",
  props: {
    mail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      note: null,
      performDate: null,
      performDisplayValue: '',
      performDateMenu: false,

      loading: false,
      isPerformFailed: false
    }
  },
  computed: {
    performDateMinValue() {
      const filteredHistory = this.mailHistory.filter(m => m.type.id === 4);
      const lastFilteredItem = filteredHistory.pop();

      const currentDate = new Date();
      const twoDaysAgo = new Date(currentDate);
      twoDaysAgo.setDate(currentDate.getDate() - 2);
      let minDate;
      let lastItemDate;

      if (lastFilteredItem && lastFilteredItem.perform && lastFilteredItem.perform.performedOn) {
        lastItemDate = new Date(lastFilteredItem.perform.performedOn);
        lastItemDate.setHours(0, 0, 0, 0);

        if (lastItemDate < twoDaysAgo && Date(this.mail.createdOn) < twoDaysAgo) {
          minDate = twoDaysAgo;
        }else if (twoDaysAgo < lastItemDate && Date(this.mail.createdOn) < lastItemDate) {
          minDate = lastItemDate;
        }else {
          minDate = this.mail.createdOn
        }
      } else {
        if(this.mail.createdOn < twoDaysAgo){
          minDate = twoDaysAgo;
        }
        else{
          minDate = this.mail.createdOn;
        }
      }
      return minDate.toISOString(true);
    },
    performDateMaxValue() {
      return Moment().toISOString(true)
    }
  },
  validations: {
    performDate: {
      required
    }
  },
  methods: {
    clear() {
      this.note = null
      this.performDate = null
      this.performDisplayValue = ''

      this.$v.$reset()
    },
    onCloseClicked() {
      this.clear()
      this.$emit('close')
    },
    onPerformDateChanged() {
      if (this.performDate) {
        this.performDisplayValue = Moment(this.performDate, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.performDisplayValue = ''
      }

      this.performDateMenu = false
    },
    onPerformClicked() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const performType = TryPerform

        this.loading = true
        this.isPerformFailed = false
        this.$store.dispatch(LAYOUT_LOADING_START)
        MailService.perform({
          mail: this.mail,
          performType: performType,
          performDate: this.performDate ? Moment(this.performDate, 'YYYY-MM-DD') : null,
          note: this.note
        })
            .then(() => {
              this.clear()
              this.$store.dispatch(APP_MAIL_PERFORMED, {mail: this.mail, performType: performType})
            })
            .catch(() => {
              this.isPerformFailed = true
            })
            .finally(() => {
              this.loading = false
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            });
      }
    }
  }
}
</script>

<style scoped>

</style>
